export const allSettled = (promises) => {
    const wrappedPromises = promises.map(prom => Promise.resolve(prom)
        .then(
            val => ({ status: "fulfilled", value: val }),
            (err: unknown) => ({ status: "rejected", reason: err })),
    );
    return Promise.all(wrappedPromises);
};
